import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface AnonymousLimitDialogProps {
  open: boolean;
  onClose: () => void;
  onSignUp: () => void;
}

export default function AnonymousLimitDialog({
  open,
  onClose,
  onSignUp,
}: AnonymousLimitDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Anonymous Mode Limits</DialogTitle>
      <DialogContent>
        <Typography paragraph>
          You are currently using T-Accounts anonymously. In this mode we limit to:
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Typography>Maximum of 3 T-Accounts visualizations</Typography>
          <Typography>Maximum of 3 documents</Typography>
        </Box>
        <Typography>
          To remove these limitations you can easily sign up for free and without a credit card. Just click the SIGN UP button.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={onSignUp}>SIGN UP</Button>
      </DialogActions>
    </Dialog>
  );
}